const stripQuotes = (val) => val?.replace(/^"|"$/g, "");

export const API_URL = stripQuotes(process.env.REACT_APP_API_URL);
export const CDN_URL = stripQuotes(process.env.REACT_APP_CDN_URL);
export const VERSION = process.env.REACT_APP_VERSION;
export const VIDEO_API_URL = stripQuotes(process.env.REACT_APP_VIDEO_API_URL);
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
